import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { H5, Small } from '../../components/Typography';
import FlexBox from '../../components/flexbox/FlexBox';

const Bookmark = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const data = [
    {
      text: '전체보기',
      path: '/naver/callmetellme/mypage',
    },
    {
      text: '북마크',
      path: '/naver/callmetellme/mypage/bookmarked-posts',
    },
    {
      text: '게시글',
      path: '/naver/callmetellme/mypage/my-posts',
    },
  ];
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: '20px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #f0f0f0',
      }}
    >
      <FlexBox
        sx={{
          alignItems: 'center',
          paddingBottom: '16px',
        }}
      >
        <img
          src={'/static/icons/star.svg'}
          alt="money"
          style={{ width: '24px', height: '24px', marginRight: '8px' }}
        />
        <H5>즐겨찾기</H5>
      </FlexBox>

      {/* Stats list */}
      <Stack spacing={1}>
        {data.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() => navigate(item.path || '')}
          >
            <Small
              sx={{
                fontSize: '16px',
                color: theme.palette.primary.greytxt,
                fontWeight: 500,
              }}
            >
              {item.text}
            </Small>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  fontSize: '18px',
                  fontWeight: 700,
                  color:
                    item.count > 0
                      ? theme.palette.primary.mainBlue
                      : theme.palette.primary.greytxt,
                }}
              >
                {item.count}
              </Typography>
              {/* <Box marginBottom={'-8px'}>
                <ChevronRight
                  color={
                    item.count > 0
                      ? theme.palette.primary.mainBlue
                      : theme.palette.primary.greytxt
                  }
                />
              </Box> */}
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default Bookmark;
